export default __webpack_public_path__ + "static/media/Switchboard.a6122c91.svg";